// window.global = window;
window.global = window;

import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from './config/environment';
import { importSync, isDevelopingApp, macroCondition } from '@embroider/macros';
import '@warp-drive/ember/install';

if (macroCondition(isDevelopingApp())) {
  importSync('./deprecation-workflow');
}

import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';
import compatModules from '@embroider/virtual/compat-modules';

// Namespace import: @sentry/ember has no default export. Webpack's CJS interop
// tolerated `import Sentry from ...`, but Vite/rolldown's strict ESM rejects it.
import * as Sentry from '@sentry/ember';

import { Amplify } from 'aws-amplify';

// Only initialize Sentry if it's enabled in the config
const sentryConfig = config['@sentry/ember']?.sentry;
if (sentryConfig?.enabled !== false) {
  console.debug('Initializing Sentry...');
  Sentry.init({
    // @sentry/ember 11 no longer reads this config itself, so pass it in.
    ...sentryConfig,
    sendDefaultPii: true,
    // We load these configurations here, so that environment.js stays serializable.
    integrations: [
      Sentry.replayIntegration({
        minReplayDuration: 1000, // 1 second
        maxReplayDuration: 5 * 60 * 1000, // 5 minutes
      }),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
      Sentry.httpContextIntegration({
        failedRequestStatusCodes: [
          [400, 499],
          [500, 599],
        ],
      }),
      Sentry.extraErrorDataIntegration(),
    ],
    // We can enable this once the API deploy is stable.
    // It adds a 'baggage' header that leads to CORS rejection.
    //tracePropagationTargets: ["localhost", /^https:\/\/api\.getproducthub\.com/],
    beforeSend(event) {
      if (event.tags?.tenant_id == '2') {
        event.environment = 'development';
      }
      return event;
    },
  });
}

const awsmobile = {
  Auth: {
    Cognito: {
      userPoolId: config.cognito.userPoolId,
      userPoolClientId: config.cognito.clientId,
      identityPoolId: config.cognito.identityPoolId,
      loginWith: {
        oauth: {
          domain: config.cognito.domain.replace('https://', ''),
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [config.REDIRECT_URL],
          redirectSignOut: [config.REDIRECT_URL],
          responseType: 'code',
        },
      },
    },
  },
  Storage: {
    S3: {
      bucket: config.storage.AWSS3.bucket,
      region: config.storage.AWSS3.region,
    },
  },
};
Amplify.configure(awsmobile);

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver.withModules(compatModules);
  inspector = setupInspector(this);
}

loadInitializers(App, config.modulePrefix, compatModules);
